module.exports = __webpack_public_path__ + "static/media/Rectangle 597.144e2cfb.png";